<template>
    <div class="order-services order-step">
        <div class="order-step__title order-services__title">Услуги
            <div class="order-services__age" v-if="mode === 'pnd' && this.filters.length">
                <div
                    :class="['order-services__age-item', { active: checkActiveAgeFilter(item) }]"
                    :key="index"
                    v-for="(item, index) in ageFilter"
                >
                    <input type="radio" :id="item.value" :value="item.value" @click="onAgeFilterClick(item)">
                    <label :for="item.value">{{ item.title }}</label>
                </div>
            </div>
        </div>
        <form class="form order-services__form" @submit.prevent="nextStep()">
            <div class="order-services__services">
                <div class="form__row order-services__filters" v-if="mode === 'pnd'">
                    <div class="form__field order-services__search" :class="{'_disabled' : isLoading}">
                        <div class="form__field-wrapper">
                            <div class="form__field-label">Найти услугу</div>
                            <input type="text" v-focus v-model.trim="serviceSearch" @keydown.enter.prevent>
                        </div>
                    </div>
                    <div class="order-services__services-filter" :class="{opened: dropdownOpened, '_disabled' : isLoading}"
                         v-if="this.filters.length">
                        <div class="order-services__services-filter-label" @click="toggleDropdown">Услуги</div>
                        <div class="order-services__services-filter-dropdpwn">
                            <div class="order-services__popup-top">
                                <div class="order-services__popup-top-back" @click.prevent="applyFilters">Назад</div>
                                <div class="order-services__popup-top-close" @click.prevent="applyFilters"></div>
                            </div>
                            <div class="order-services__services-filter-list">
                                <div class="order-services__services-filter-item checkbox" v-for="item in filters"
                                     :key="item.id">
                                    <input type="checkbox" :id="item.CODE" v-model="serviceFilter" :value="item">
                                    <label :for="item.CODE"><span class="checkbox-icon"></span>{{ item.NAME }}</label>
                                </div>
                            </div>
                            <div class="order-services__services-filter-btns">
                                <button class="button button_light" @click.prevent="clearFilters">Очистить</button>
                                <button class="button button_dark" @click.prevent="applyFilters">Применить</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-services__filters-checked" v-if="serviceFilter.length">
                    <div class="order-services__filters-checked-item" v-for="(item, index) in serviceFilter"
                         :key="index">{{ item.NAME }}<span @click="uncheckFilterItem(item)"></span></div>
                    <button @click="clearFilters">Очистить</button>
                </div>

                <div v-if=isLoading class="order-services__preloader">
                    <div class="spinner" />
                </div>

                <template v-else-if="servicesDisplay && servicesDisplay.length">
                    <div class="order-services__services-list">
                        <div
                            :key="item.id"
                            class="order-services__services-item"
                            v-for="item in showAll ? servicesDisplay : servicesDisplay.slice((pageActive-1) * pageLimit, pageActive * pageLimit)"
                        >
                            <div class="order-services__services-item-top">
                                <div class="order-services__services-item-title" @click="openService(item.id)"
                                     :class="{'has-desc': item.desc}">{{ item.title }}
                                </div>
                                <count v-if="item.enum" :num.sync="item.num" :min-val="1"
                                       :key="`${item.id}-${item.num}`" @update="syncQuantity(item)"></count>
                                <div class="order-services__services-item-price">
                                    {{ item.price | formatNumber }}
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                                            <path d="M0.94043 5.9519H2.07643V0.8479H5.00443C5.54843 0.8479 6.04443 0.9119 6.49243 1.0399C6.94043 1.15723 7.32443 1.3439 7.64443 1.5999C7.96443 1.84523 8.2151 2.1599 8.39643 2.5439C8.57776 2.9279 8.66843 3.38657 8.66843 3.9199C8.66843 4.45323 8.57243 4.91723 8.38043 5.3119C8.18843 5.70657 7.9271 6.03723 7.59643 6.3039C7.26577 6.5599 6.87643 6.7519 6.42843 6.8799C5.98043 7.0079 5.4951 7.0719 4.97243 7.0719H3.35643V8.6879H5.93243V9.7439H3.35643V11.9999H2.07643V9.7439H0.94043V8.6879H2.07643V7.0719H0.94043V5.9519ZM5.00443 5.9519C5.74043 5.9519 6.31643 5.78657 6.73243 5.4559C7.1591 5.11457 7.37243 4.60257 7.37243 3.9199C7.37243 3.23723 7.1591 2.74123 6.73243 2.4319C6.31643 2.12257 5.74043 1.9679 5.00443 1.9679H3.35643V5.9519H5.00443Z" fill="black"/>
                                        </svg>
                                    </span>
                                </div>
                                <button class="button button_small"
                                        :class="{'button_light':item.checked, 'button_light-green': !item.checked}"
                                        @click.prevent="toggleService(item)"
                                >
                                    {{ item.checked ? 'Удалить' : 'Добавить' }}
                                </button>
                            </div>
                            <transition
                                name="accordion"
                                v-on:before-enter="beforeEnter" v-on:before-leave="beforeLeave"
                                v-on:enter="enter" v-on:leave="leave"
                            >
                                <div
                                    :class="['order-services__services-item-desc', { opened: serviceOpened === item.id }]"
                                    v-if="item.desc"
                                    v-show="serviceOpened === item.id"
                                >
                                    <span v-html="item.desc"></span> <span
                                    class="order-services__services-item-desc-hide"
                                    @click="openService(item.id)">Скрыть</span>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="order-services__pagination" v-if="pagesCount > 1 && !showAll">
                        <paginate
                            v-model="pageActive"
                            :page-count="pagesCount"
                            :container-class="'order-services__pagination-pages'"
                            :prev-link-class="'hidden'"
                            :next-link-class="'hidden'"
                            :no-li-surround="true"
                        />
                        <div class="order-services__pagination-showall" @click="showAll = true">Показать все</div>
                    </div>
                    <div class="order-services__price-disclaimer" v-html="priceDisclaimer"></div>
                </template>

                <div v-else style="text-align: center; margin-top: 30px; margin-bottom: 30px;">
                    Нет результатов
                </div>
                <div class="order-services__buttons">
                    <button class="button button_light" @click.prevent="prevStep">Назад</button>
                    <button class="button button_dark" :disabled="!total"><span>Перейти к оформлению</span></button>
                </div>
            </div>
            <div class="order-services__order-shadow" v-if="orderOpened"></div>
            <div class="order-services__order-wrapper" sticky-container>
                <div
                    class="order-services__order"
                    v-sticky-order v-sticky="isDesktop"
                    :class="{opened: orderOpened}"
                    sticky-offset="{top: 70}"
                >
                    <div class="order-services__order-border">
                        <div @click="viewOrder" class="_g-visible-tablet order-services__order-open" v-if="orderServices.length || orderOpened" />
                        <div class="order-services__order-top">
                            <div class="order-services__order-title">Ваш заказ</div>
                            <vue-custom-scrollbar
                                :settings="scrollBarSettings"
                                :swicher="isCustomScrollbarActive"
                                class="order-services__order-list-scroll"
                                data-scroll-lock-scrollable
                            >
                                <div class="order-services__order-list">
                                    <div
                                        :key="index"
                                        class="order-services__order-item"
                                        v-for="(item, index) in orderServices"
                                    >
                                        <div class="order-services__order-item-top">
                                            <div class="order-services__order-item-name">
                                                {{ item.title }}
                                                <span class="order-services__order-item-desc" v-if="item.descPrice"><br>{{ item.descPrice }}</span>
                                            </div>
                                            <div class="order-services__order-item-price">
                                                {{ (item.id === 'fake_nurse' || item.id === 'fake_nurse_uzi' || item.hasPriceWeekend) ? 'от' : '' }} {{ item.price | formatNumber}}
                                                <span>
                                                    <svg fill="none" height="11" viewBox="0 0 9 12" width="9" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0.94043 5.9519H2.07643V0.8479H5.00443C5.54843 0.8479 6.04443 0.9119 6.49243 1.0399C6.94043 1.15723 7.32443 1.3439 7.64443 1.5999C7.96443 1.84523 8.2151 2.1599 8.39643 2.5439C8.57776 2.9279 8.66843 3.38657 8.66843 3.9199C8.66843 4.45323 8.57243 4.91723 8.38043 5.3119C8.18843 5.70657 7.9271 6.03723 7.59643 6.3039C7.26577 6.5599 6.87643 6.7519 6.42843 6.8799C5.98043 7.0079 5.4951 7.0719 4.97243 7.0719H3.35643V8.6879H5.93243V9.7439H3.35643V11.9999H2.07643V9.7439H0.94043V8.6879H2.07643V7.0719H0.94043V5.9519ZM5.00443 5.9519C5.74043 5.9519 6.31643 5.78657 6.73243 5.4559C7.1591 5.11457 7.37243 4.60257 7.37243 3.9199C7.37243 3.23723 7.1591 2.74123 6.73243 2.4319C6.31643 2.12257 5.74043 1.9679 5.00443 1.9679H3.35643V5.9519H5.00443Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <div @click="toggleService(item)" class="order-services__order-item-close" />
                                            </div>
                                        </div>
                                        <count v-if="item.enum" :num.sync="item.num" :key="`${item.id}-${item.num}`"
                                               @update="checkZero(item.id, item.num)"></count>
                                    </div>
                                </div>
                            </vue-custom-scrollbar>
                        </div>
                        <div class="order-services__order-bottom">
                            <div class="order-services__order-list-warning" v-if="orderListWarning">
                                {{ orderListWarning }}
                            </div>

                            <div class="order-services__order-total">
                                <div class="order-services__order-total-label">Итого</div>
                                <div class="order-services__order-total-value">
                                    {{ total | formatNumber }}
                                    <span>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14"
                                       fill="none">
                                     <path
                                         d="M0.542969 6.8759H2.03697V0.899902H5.38497C6.18897 0.899902 6.87297 1.0139 7.43697 1.2419C8.00097 1.4579 8.45697 1.7519 8.80497 2.1239C9.16497 2.4839 9.42297 2.9099 9.57897 3.4019C9.74697 3.8819 9.83097 4.3799 9.83097 4.8959C9.83097 5.4239 9.74697 5.9219 9.57897 6.3899C9.42297 6.8579 9.16497 7.2719 8.80497 7.6319C8.45697 7.9919 8.00097 8.2799 7.43697 8.4959C6.87297 8.6999 6.18897 8.8019 5.38497 8.8019H4.37697V10.1699H7.54497V12.0239H4.37697V13.4999H2.03697V12.0239H0.542969V10.1699H2.03697V8.8019H0.542969V6.8759ZM5.15097 6.8759C5.47497 6.8759 5.77497 6.8519 6.05097 6.8039C6.33897 6.7439 6.59097 6.6419 6.80697 6.4979C7.02297 6.3539 7.19097 6.1559 7.31097 5.9039C7.43097 5.6399 7.49097 5.3039 7.49097 4.8959C7.49097 4.4879 7.43097 4.1459 7.31097 3.8699C7.19097 3.5939 7.02297 3.3779 6.80697 3.2219C6.59097 3.0539 6.33897 2.9399 6.05097 2.8799C5.77497 2.8079 5.47497 2.7719 5.15097 2.7719H4.37697V6.8759H5.15097Z"
                                         fill="black"/>
                                  </svg>
                              </span>
                                </div>
                            </div>
                            <!--                            <div v-if="pageCode === 'help' && currentRegionCode === 'moscow'" class="order-services__order-disclaimer">-->
                            <!--                                Сформирована предварительная цена. Точная цена будет подготовлена на последнем шаге-->
                            <!--                            </div>-->
                            <button class="order-services__order-btn button button_dark" :disabled="!total">
                                <span class="_g-hidden-tablet">Перейти к оформлению</span>
                                <span class="_g-visible-tablet-only">К оформлению</span>
                                <span class="_g-visible-mobile">Перейти к оформлению</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import Sticky from 'vue-sticky-directive';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import Paginate from 'vuejs-paginate'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import Count from './Count';
import getUrlParams from '../assets/js/getUrlParams';
import convertModelToFormData from '../assets/js/convertModelToFormData';

const DISCLAIMER_NURSE = 'Стоимость услуги вызова медсестры будет уточнена на следующем шаге';
const DISCLAIMER_UZI_NURSE = 'Стоимость услуги вызова врача УЗИ будет уточнена на следующем шаге';
const DISCLAIMER_PRICE_WEEKEND = 'Стоимость услуги будет уточнена на следующем шаге после указания даты приема.';

export default {
    name: 'OrderServices',
    props: {
        filters: {
            type: Array,
            required: true,
        },
        orderTemp: {
            type: Array,
            default: () => [],
        },
        mode: {
            type: String,
            default: 'pnd',
        },
        medsiServiceArea: {
            type: Object,
            default: () => ({}),
        },
        enableAutoNurse: {
            type: Boolean,
            default: true,
        },
        autoNurse: {
            type: Object,
        },
        nurse: {
            type: Object,
        },
        pageCode: {
            type: String,
            default: 'help',
        },
        serviceAreaLimitation: {
            type: Boolean,
            default: false,
        },
        servicesWeekend: {
            type: Object,
            default: () => {}
        },
        servicesWeekendIds: {
            type: Array,
            default: () => []
        },
        orderInfo: {
            type: Object
        },
        currentAddress: {
            type: Object
        },
        currentRegionCode: {
            type: String,
            default: 'moscow',
        },
        priceDisclaimer: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            ageFilter: [
                {
                    title: 'Для взрослых',
                    value: 'adults',
                    filters: [{CODE: 'UF_DOC_AD'}, {CODE: 'UF_NURSE_AD'}],
                },
                {
                    title: 'Для детей',
                    value: 'children',
                    filters: [{CODE: 'UF_DOC_CH'}, {CODE: 'UF_NURSE_CH'}],
                },
            ],
            servicesList: [],
            serviceSearch: '',
            serviceFilter: [],
            dropdownOpened: false,
            orderServices: [],
            serviceOpened: null,
            isDesktop: window.matchMedia('(min-width: 1025px)').matches,
            orderOpened: false,
            pageLimit: 10,
            pageActive: 1,
            showAll: false,
            isCustomScrollbarActive: true,
            scrollBarSettings: {
                suppressScrollY: false,
                suppressScrollX: false,
                wheelPropagation: false,
                wheelSpeed: 0.3,
            },
            therapist: {
                adults: null,
            },
            fakeNurse: {
                id: 'fake_nurse',
                auto: true,
                autoType: 'nurse',
                checked: false,
                desc: 'Описание',
                descPrice: DISCLAIMER_NURSE,
                mkad: -1,
                num: 1,
                enum: false,
                price: 500,
                sort: 0,
                title: 'Вызов медсестры',
            },
            fakeUziNurse: {
                id: 'fake_nurse_uzi',
                auto: true,
                autoType: 'uzi',
                checked: false,
                desc: 'Описание',
                descPrice: DISCLAIMER_UZI_NURSE,
                mkad: -1,
                num: 1,
                enum: false,
                price: 500,
                sort: 0,
                title: 'Вызов врача УЗИ',
            },
            countNurseAdd: 0,
            orderListWarning: null,
            orderListWarningTimeout: null,
            isLoading: true,
        }
    },
    methods: {
        async getServices() {
            this.isLoading = true;
            let body = {};

            if (this.serviceAreaLimitation) {
                const { id, regionCode } = this.medsiServiceArea;

                body = {
                    zone: id,
                    page: {
                        code: this.pageCode,
                        region: {
                            code: regionCode
                        },
                    },
                    'address[flat]': this.currentAddress.flat ? this.currentAddress.flat : '',
                    'address[entrance]': this.currentAddress.entrance ? this.currentAddress.entrance : '',
                    'address[floor]': this.currentAddress.floor ? this.currentAddress.floor : '',
                    'address[intercom]': this.currentAddress.intercom ? this.currentAddress.intercom : '',
                    'address[request]': this.currentAddress.request ? this.currentAddress.request : '',
                    age: this.getAge(this.orderInfo.namePatient ? this.orderInfo.birthPatient : this.orderInfo.birth),
                    longitude: this.currentAddress.coords[1],
                    latitude: this.currentAddress.coords[0],
                    date: this.localeDateCustom(this.orderInfo.receiptDate) + (this.orderInfo.receiptTime ? ' ' + this.orderInfo.receiptTime.slice(0,5) : ''),
                }
            }

            try {
                const { data: result } = await axios.post('/api/2.0/eruservices/list/', convertModelToFormData(body));
                this.servicesList = result.data;
                this.$emit('update:services-list', this.servicesList);

                if (this.enableAutoNurse) {
                    await this.findNurse();
                    await this.findTherapist();
                }
            } catch (e) {
                console.error(e);
            }

            this.isLoading = false;
        },
        getAge(birthday) {
            const birthdayArray = birthday.split('.')
            const date = new Date(+birthdayArray[2], +birthdayArray[1]-1, +birthdayArray[0]); //Дата рождения
            const timeDiff = Math.abs(new Date() - date);
            const diff = Math.ceil(timeDiff / ((1000 * 3600 * 24)) / 365);
            return diff;
        },
        nextStep() {
            enablePageScroll();
            this.replaceNurse();
            this.$emit('next');
            this.$emit('update:order-temp', this.orderServices);
        },
        prevStep() {
            this.$emit('prev');
            this.$emit('update:order-temp', this.orderServices);
        },
        toggleDropdown() {
            this.dropdownOpened = !this.dropdownOpened;
        },
        clearFilters() {
            this.serviceFilter = [];
        },
        applyFilters() {
            this.toggleDropdown()
        },
        uncheckFilterItem(value) {
            this.serviceFilter = this.serviceFilter.filter(item => item !== value);
        },
        beforeEnter(el) {
            el.style.height = '0';
        },
        enter(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave(el) {
            el.style.height = '0';
        },
        isChecked(id) {
            return this.orderServices.find(x => x.id === id);
        },
        toggleService(item) {
            if (this.isChecked(item.id)) {
                if (!this.isAutoNurse(item)) {
                    this.orderServices = this.orderServices.filter(x => x.id !== item.id);
                    this.$emit('update:order-temp', this.orderServices);

                    if (this.enableAutoNurse) {
                        this.checkAutoNurse();
                    }
                } else {
                    this.showAutoNurseWarning();
                }
            } else {
                this.orderServices.push(item);
                this.$emit('update:order-temp', this.orderServices);

                if (this.enableAutoNurse) {
                    this.checkAutoNurse();
                }
            }

        },
        isAutoNurse(item) {
            return item.auto;
        },
        getAutoType(item) {
            return item.autoType || (item.auto ? 'nurse' : null);
        },
        isAutoType(item, type) {
            return item.auto && this.getAutoType(item) === type;
        },
        showAutoNurseWarning() {
            this.orderListWarning = 'В корзине присутствуют медицинские манипуляции, которые должна выполнять медсестра или врач.';

            if (this.orderListWarningTimeout) {
                clearTimeout(this.orderListWarningTimeout);
            }

            this.orderListWarningTimeout = setTimeout(() => {
                clearTimeout(this.orderListWarningTimeout);
                this.orderListWarningTimeout = null;
                this.orderListWarning = null;
            }, 5000);
        },
        checkAutoNurse() {
            this.checkRegularAutoNurse();
            this.checkUziAutoNurse();
        },
        checkRegularAutoNurse() {
            let autoNurse = this.autoNurse?.adults;
            if (!autoNurse || (!this.nurse.adults && !this.nurse.children)) {
                this.removeNurse('nurse');
                return;
            }

            let countAutoAdd = 0;
            let existCountAutoAdd = 0;
            let needAddMain = false;
            let needAddFiz = false;
            let needAddTer = false;

            // Проверяем был ли добавлен терапевт
            // Некоторые медсестринские услуги на дому могут сделать терапевты\педиатры,
            // т.е. если у нас в корзине есть вызов терапевта, то для таких услуг добавлять м\с не нужно.
            // В таблице коды таких услуг в столбце G. Коды вызова терапевта\педиатра в столбце F.
            let isTherapistAdd = this.orderServices.find(x => (autoNurse.therapists || []).includes(x.id));
            let isNotNeedAutoAdd = false;

            this.orderServices.forEach(function (service) {
                if (service.auto) return;

                if ((autoNurse.not_auto_add || []).indexOf(service.id) !== -1 && isTherapistAdd) {
                    isNotNeedAutoAdd = true;
                }

                //Добавлена услуга с кодом “Z” – это комплексные программы, куда уже входит вызов м\с
                if (String(service.id).charAt(0) === 'Z') {
                    isNotNeedAutoAdd = true;
                }

                if (!isNotNeedAutoAdd) {
                    if (!needAddMain && (autoNurse.nurse_add?.main || []).indexOf(service.id) !== -1) {
                        needAddMain = true;
                        countAutoAdd++;
                    }
                    if (!needAddFiz && (autoNurse.nurse_add?.fiz || []).indexOf(service.id) !== -1) {
                        needAddFiz = true;
                        countAutoAdd++;
                    }
                    if (!needAddTer && (autoNurse.nurse_add?.ter || []).indexOf(service.id) !== -1) {
                        needAddTer = true;
                        countAutoAdd++;
                    }
                }
            });

            if (countAutoAdd > existCountAutoAdd && !isNotNeedAutoAdd) {
                let counterAdd = countAutoAdd - existCountAutoAdd;

                if (counterAdd > 0) {
                    this.pushNurse(counterAdd);
                }
            } else {
                this.removeNurse('nurse');
            }
        },
        checkUziAutoNurse() {
            const adultUzi = this.autoNurse?.adults_uzi;
            const childUzi = this.autoNurse?.children_uzi;
            const uziAddIds = []
                .concat(adultUzi?.nurse_add?.main || [])
                .concat(childUzi?.nurse_add?.main || []);

            if (!uziAddIds.length || (!this.nurse.adults_uzi && !this.nurse.children_uzi)) {
                this.removeNurse('uzi');
                return;
            }

            const needAddUzi = this.orderServices.some((service) => {
                return !service.auto && uziAddIds.includes(service.id);
            });

            if (needAddUzi) {
                this.pushUziNurse();
            } else {
                this.removeNurse('uzi');
            }
        },
        pushNurse(countPush = 1) {
            //Нужно еще проверять может это быть МС для взрослых или только МС для детей. А может и та и та быть.
            this.removeNurse('nurse');
            if (countPush > 1) {
                this.fakeNurse.num = countPush;
                this.fakeNurse.enum = true;
            } else {
                this.fakeNurse.num = countPush;
                this.fakeNurse.enum = false;
            }
            if (this.nurse.adults) {
                this.orderServices = this.orderServices.filter(x => x.id !== this.nurse.adults.id);
            }
            if (this.nurse.children) {
                this.orderServices = this.orderServices.filter(x => x.id !== this.nurse.children.id);
            }

            this.orderServices.push(this.fakeNurse)
        },
        pushUziNurse() {
            this.removeNurse('uzi');
            this.fakeUziNurse.num = 1;
            this.fakeUziNurse.enum = false;

            if (this.nurse.adults_uzi) {
                this.orderServices = this.orderServices.filter(x => x.id !== this.nurse.adults_uzi.id);
            }
            if (this.nurse.children_uzi) {
                this.orderServices = this.orderServices.filter(x => x.id !== this.nurse.children_uzi.id);
            }

            this.orderServices.push(this.fakeUziNurse);
        },
        removeNurse(type) {
            this.orderServices = this.orderServices.filter(x => !(x.auto && this.getAutoType(x) === type));
        },
        findNurse() {
            let nurse = this.autoNurse || {};
            this.nurse.adults = this.servicesDisplay.find(x => nurse.adults?.nurse_list.includes(x.id));
            this.nurse.children = this.servicesDisplay.find(x => nurse.children?.nurse_list.includes(x.id));
            this.nurse.adults_uzi = this.servicesDisplay.find(x => nurse.adults_uzi?.nurse_list.includes(x.id));
            this.nurse.children_uzi = this.servicesDisplay.find(x => nurse.children_uzi?.nurse_list.includes(x.id));

            if (this.nurse.adults) {
                this.fakeNurse.price = this.nurse.adults.price;
            }
            if (this.nurse.children) {
                this.fakeNurse.price = this.nurse.children.price;
            }
            if (this.nurse.children && this.nurse.adults) {
                this.fakeNurse.price = Math.min(this.nurse.adults.price, this.nurse.children.price);
            }
            if (this.nurse.adults_uzi) {
                this.fakeUziNurse.price = this.nurse.adults_uzi.price;
            }
            if (this.nurse.children_uzi) {
                this.fakeUziNurse.price = this.nurse.children_uzi.price;
            }
            if (this.nurse.children_uzi && this.nurse.adults_uzi) {
                this.fakeUziNurse.price = Math.min(this.nurse.adults_uzi.price, this.nurse.children_uzi.price);
            }
        },
        findTherapist() {
            let nurse = this.autoNurse || {};
            if (nurse?.adults?.therapists?.length) {
                this.therapist.adults = this.servicesDisplay.find(x => nurse.adults.therapists.includes(x.id));
            } else {
                this.therapist.adults = {'id': false};
            }

        },
        syncQuantity(item) {
            if (item.checked) {
                this.orderServices.find(x => x.id === item.id).num = item.num;
            } else {
                this.toggleService(item);
            }
        },
        openService(id) {
            if (this.serviceOpened == id) {
                this.serviceOpened = null;
                return;
            }
            this.serviceOpened = id;
        },
        checkZero(id, num) {
            if (!num) {
                this.orderServices = this.orderServices.filter(x => x.id !== id);
            }
        },
        viewOrder() {
            this.orderOpened = !this.orderOpened;

            const siteScrollTop = document.documentElement.scrollTop;
            const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const footerEl = document.getElementById('footer');
            const {top} = footerEl.getBoundingClientRect();
            const footerTop = top + siteScrollTop - screenHeight;

            if (this.orderOpened && (siteScrollTop > footerTop)) {
                this.$scrollTo(document.documentElement, 300, {
                    offset: footerTop,
                    force: true,
                    cancelable: false,
                    onDone: disablePageScroll,
                });
            } else {
                this.orderOpened ? disablePageScroll() : enablePageScroll();
            }
        },
        stickyHack() {
            this.$nextTick(() => {
                let event;
                if (typeof (Event) === 'function') {
                    event = new Event('scroll');
                } else {
                    event = document.createEvent('Event');
                    event.initEvent('scroll', true, true);
                }
                window.dispatchEvent(event);
            });
        },
        setAgeFilters(ageFilter) {
            const filterCodesFull = this.ageFilter.flat().reduce((arr, item) => {
                return arr.concat(item.filters);
            }, []).map(({CODE}) => CODE);
            const filterCodes = ageFilter.filters.map(({CODE}) => CODE);

            const serviceFilters = filterCodes
                .map((code) => {
                    return this.filters.find(({CODE}) => CODE === code);
                })
                .filter((filter) => filter);

            this.serviceFilter = this.serviceFilter.filter(item => !filterCodesFull.includes(item.CODE)).concat(serviceFilters);
        },
        onAgeFilterClick(ageFilter) {
            this.setAgeFilters(ageFilter);
        },
        checkActiveAgeFilter(ageFilter) {
            return ageFilter.filters.every(
                (filter) => this.serviceFilter.find((servFilter) => servFilter.CODE === filter.CODE),
            );
        },
        getDefaultFiltersFromQuery() {
            const {services} = getUrlParams();
            if (!services) return;

            const filterCodes = services.split(',');

            const selectedFilters = filterCodes
                .map((code) => {
                    return this.filters.find(({CODE}) => CODE === code);
                })
                .filter((filter) => filter);

            Object.assign(this.serviceFilter, {
                ...selectedFilters,
            })
        },
        handleResize() {
            this.isCustomScrollbarActive = window.matchMedia('(min-width: 1024px)').matches;
        },
        localeDateCustom(date) {
            function checkLength(num) {
                return num.toString().length === 1 ?
                    '0' + num.toString() : num
            }
            return checkLength(date.getDate()) + '.' + checkLength((+date.getMonth() + 1)) + '.' + date.getFullYear()
        },
        replaceNurse() {
            let nurseExist = this.orderServices.find(x => this.isAutoType(x, 'nurse'));
            let uziNurseExist = this.orderServices.find(x => this.isAutoType(x, 'uzi'));
            const baby = this.getAge(this.orderInfo.namePatient ? this.orderInfo.birthPatient : this.orderInfo.birth) < 18;
            if (nurseExist) {
                this.removeNurse('nurse');
                if (!baby && this.nurse.adults) {
                    this.nurse.adults.auto = true;
                    this.nurse.adults.autoType = 'nurse';
                    this.orderServices.push(this.nurse.adults)
                } else if (baby && this.nurse.children) {
                    this.nurse.children.auto = true;
                    this.nurse.children.autoType = 'nurse';
                    this.orderServices.push(this.nurse.children)
                }
            }
            if (uziNurseExist) {
                this.removeNurse('uzi');
                if (!baby && this.nurse.adults_uzi) {
                    this.nurse.adults_uzi.auto = true;
                    this.nurse.adults_uzi.autoType = 'uzi';
                    this.orderServices.push(this.nurse.adults_uzi)
                } else if (baby && this.nurse.children_uzi) {
                    this.nurse.children_uzi.auto = true;
                    this.nurse.children_uzi.autoType = 'uzi';
                    this.orderServices.push(this.nurse.children_uzi)
                }
            }
        },
    },
    watch: {
        orderServices() {
            this.stickyHack();
        },
        pagesCount() {
            this.pageActive = 1;
        },
    },
    components: {
        Count,
        Paginate,
        vueCustomScrollbar,
    },
    directives: { Sticky },
    computed: {
        servicesDisplay() {
            const searchInputValue = this.serviceSearch.toLowerCase();
            let searchedServices = this.servicesList.filter(service => {
                    const id = service.id;
                    const isServiceWeekend = this.servicesWeekendIds.includes(id);

                    if (this.servicesWeekend[id]) {
                        service.hasPriceWeekend = true;
                        service.descPrice = DISCLAIMER_PRICE_WEEKEND;
                    }

                    return !isServiceWeekend &&
                        (
                            service.title.toLowerCase().includes(searchInputValue) ||
                            id.toLowerCase().includes(searchInputValue)
                        )
                }
            );

            let result = searchedServices.map((item) => (
                {
                    ...item,
                    num: item.enum ? this.isChecked(item.id) && this.isChecked(item.id).num != 0 ? this.isChecked(item.id).num : 1 : 1,
                    checked: !!this.isChecked(item.id),
                }
            ));

            // filter service list on selected checkbox
            if (this.serviceFilter.length) {

                // put all selected checkbox codes to array
                let serviceFilterArr = [];
                this.serviceFilter.forEach((item) => {
                    serviceFilterArr.push(item.CODE.slice(3));
                });

                // return the ones that have matches in selected filters and service.filters
                return result.filter((service) => {
                    for (let key in service.filters) {
                        if (serviceFilterArr.includes(key)) return true;
                    }
                });
            }

            return result;
        },
        pagesCount() {
            return Math.ceil(this.servicesDisplay.length / this.pageLimit);
        },
        total() {
            return this.orderServices.length ? this.orderServices.reduce(function (acc, obj) {
                return acc + obj.price * obj.num
            }, 0) : 0;
        },
    },
    created() {
        this.getServices();
    },
    mounted() {
        this.orderServices = this.orderTemp;
        // т.к. на шаге услуг в корзину добавляется "фейковая медсестра", при переходе назад она сбрасывается.
        // "настоящая медсестра" добавлятеся на шаге оплаты
        // при возврате на страницу, если есть услуги нужно проверять, есть ли "настоящая медсестра"
        // и если ее нет нужно ли добавить "фейковую медсестру"
        if(this.orderServices.length && !this.orderServices.find(x => x.auto)?.auto) {
            this.checkAutoNurse();
        }

        // hack for sticky order
        setTimeout(() => {
            let scrollY = (window.scrollY) ? window.scrollY : document.documentElement.scrollTop;
            window.scrollTo(window.scrollX, scrollY - 1);
            window.scrollTo(window.scrollX, scrollY + 1);
        }, 10);

        this.getDefaultFiltersFromQuery();
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    updated: function () {
        setTimeout(() => {
            this.stickyHack();
        }, 10);
    },
}
</script>

<style lang="scss">
@import "../../scss/base/include";

.order-services {
    position: relative;
    margin-bottom: 101px !important;
    min-height: 600px;
    @include tablet {
        position: static !important;
        min-height: 620px;
    }
    @include mobile {
        margin-bottom: 0 !important;
        padding-bottom: 59px !important;
    }

    &::after {
        content: '';
        position: absolute;
        width: 132px;
        height: 115px;
        background: center url(/local/templates/pnd/src/assets/i2/decor.png) no-repeat;
        z-index: -1;
        right: -55px;
        bottom: -50px;
        @include tablet {
            display: none;
        }
    }

    &__preloader {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        @include mobile {
            height: 150px;
        }
    }

    &__title {
        margin-bottom: 47px;
        display: flex;
        align-items: baseline;
        @include tablet {
            margin-bottom: 25px;
        }
        @include mobile {
            justify-content: space-between;
            margin-bottom: 15px;
        }
    }

    &__age {
        display: flex;
        margin-left: 17px;
        font-size: 14px;
        line-height: 17px;
        font-weight: normal;

        &-item {
            margin-right: 20px;
            color: rgba(0, 171, 170, 0.8);
            @include mobile {
                margin-right: 0;
                margin-left: 20px;
            }

            &.active {
                color: $accent;
            }

            label {
                cursor: pointer;
            }

            input {
                display: none;
            }
        }
    }

    &__popup {
        &-top {
            display: none;
            @include mobile {
                display: flex;
                height: 47px;
                align-items: center;
                justify-content: space-between;
                &-back {
                    color: $accent;
                    font-size: 14px;
                    line-height: 17px;
                    -webkit-tap-highlight-color: transparent;

                    &::before {
                        content: '';
                        width: 15px;
                        height: 9px;
                        background: center url(/local/templates/pnd/src/assets/i2/dropdown.svg) no-repeat;
                        display: inline-block;
                        transform: rotate(90deg);
                        margin: 0 4px 0 -4px;
                    }
                }
                &-close {
                    background: center url(/local/templates/pnd/src/assets/i2/close2.svg) no-repeat;
                    width: 28px;
                    height: 28px;
                    -webkit-tap-highlight-color: transparent;
                }
            }
        }
    }

    &__form {
        display: flex;
        justify-content: space-between;

        .vue-sticky-placeholder {
            width: 320px;
            float: right;
        }
    }

    &__services {
        width: calc(100% - 380px);
        @include low-desktop {
            width: calc(100% - 360px);
        }
        @include tablet {
            width: 100%;
            padding-bottom: 40px;
        }
        @include mobile {
            padding-bottom: 0px;
        }
        float: left;

        &-list {
            margin-bottom: 18px;
            @include tablet {
                border-top: 1px solid rgba(125, 121, 135, 0.15);
            }
            @include mobile {
                border-top: none;
            }
        }

        &-item {
            border-bottom: 1px solid rgba(125, 121, 135, 0.15);

            &-top {
                padding: 10px 0;
                display: flex;
                align-items: center;
                @include mobile {
                    padding: 14px 0 20px 0;
                    flex-wrap: wrap;
                    align-items: baseline;
                    .count {
                        order: 1;
                    }
                }
            }

            &-title {
                width: 50%;
                font-size: 16px;
                line-height: 140%;
                @include mobile {
                    width: 70%;
                    margin-bottom: 15px;
                }

                &.has-desc {
                    cursor: pointer;

                    &:hover {
                        color: $accent;
                    }
                }
            }

            &-price {
                font-size: 16px;
                line-height: 19px;
                margin-left: auto;
                width: 100px;
                min-width: 100px;
                text-align: right;
                @include mobile {
                    width: 30%;
                    font-weight: 500;
                    min-width: 0;
                    padding-right: 12px;
                }
            }

            &-desc {
                padding-right: 120px;
                padding-bottom: 0;
                font-size: 14px;
                line-height: 159.8%;
                color: $gray;
                transition: all ease .3s;
                overflow: hidden;

                &.opened {
                    padding-bottom: 21px;
                }

                @include mobile {
                    padding-right: 0px;
                }

                &-hide {
                    color: $accent;
                    cursor: pointer;
                    display: inline-block;
                }
            }

            .button {
                width: 110px;
                margin: 0 0 0 19px;
                @include mobile {
                    order: 2;
                    margin: 0 0 0 auto;
                }
            }
        }
    }

    &__order {
        float: right;
        width: 320px !important;
        box-sizing: border-box;
        transform: translate3d(0, 0, 0);

        &-wrapper {
            width: 320px;
            @include tablet {
                width: auto;
            }
        }

        &-disclaimer {
            width: 100%;
            order: 2;
            padding: 15px 0;
            color: #7D7987;
            font-size: 14px;
            line-height: 21px;

            @include tablet-only {
                order: 3;
            }

            @include mobile {
                padding: 15px 8px;
            }
        }

        &-list-scroll {
            margin-right: -20px;
            padding-right: 20px;
            overflow: hidden;
            max-height: 465px;

            @include tablet {
                margin-right: 0;
                overflow-y: auto;
                padding-right: 12px;
                max-height: 45vh;
            }
        }

        @include tablet {
            transform: translate3d(0, 0, 0);
            position: fixed;
            bottom: 0;
            background-color: $white-true;
            width: 100% !important;
            left: 0;
            z-index: 99;
            &.abs {
                position: absolute;
            }
            &-top {
                max-height: 0;
                overflow: hidden;
                transition: all ease .3s;
                margin-right: -12px;

                .opened & {
                    display: block;
                    max-height: 999px;
                    margin-bottom: 17px;
                }
            }
            &-bottom {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                @include mobile {
                    display: block;
                }
            }
            &-open {
                display: block;
                position: absolute;
                background: center url(/local/templates/pnd/src/assets/i2/dropdown.svg) no-repeat;
                background-position-y: 2px;
                height: 17px;
                width: 100%;
                transform: rotate(180deg) translateX(-50%);
                top: 0;
                left: -50%;
                margin-left: 0;

                .opened & {
                    transform: rotate(0) translateX(-50%);
                    left: 50%;
                    background-position-y: 6px;
                }
            }
        }
        @include mobile {
            &-list {
                padding-top: 14px;
                border-top: 1px solid rgba(125, 121, 135, 0.15);
            }
        }

        &-list-warning {
            padding: 0.5em;
            margin: 1em 0;
            border: 1px solid #ffeeba;
            border-radius: 0.25em;
            color: #856404;
            background-color: #fff3cd;
            font-size: 0.9em;
        }

        &-border {
            border: 1px solid rgba(125, 121, 135, 0.2);
            padding: 26px 20px 20px;
            border-radius: 5px;
            @include tablet {
                box-shadow: 10px -19px 50px rgba(0, 0, 0, 0.12);
                padding: 26px 60px 20px;
                border-radius: 0;
                border: none;
            }
            @include mobile {
                padding: 12px 12px 20px;
            }
        }

        &-shadow {
            position: fixed;
            z-index: 100;
            background: rgba(125, 121, 135, 0.34);
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        &-title {
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
            margin-bottom: 24px;
            @include mobile {
                font-size: 16px;
                line-height: 20px;
                margin-bottom: 16px;
                margin-top: 22px;
                padding: 0 15px;
            }
        }

        &-item {
            border-bottom: 1px solid rgba(125, 121, 135, 0.15);
            padding-bottom: 23px;
            @include mobile {
                padding-bottom: 20px;
            }

            &:not(:last-child) {
                margin-bottom: 27px;
            }

            &-top {
                display: flex;
                justify-content: space-between;
            }

            &-price {
                white-space: nowrap;
                font-size: 14px;
                @include mobile {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 500;
                }
            }

            &-name {
                max-width: 238px;
                font-size: 14px;
                line-height: 18px;
                padding-right: 20px;
                @include tablet {
                    max-width: none;
                }
                @include mobile {
                    font-size: 16px;
                    line-height: 22px;
                }
            }

            &-close {
                display: inline-block;
                width: 8px;
                height: 8px;
                background: center url(/local/templates/pnd/src/assets/i2/close.svg) no-repeat;
                margin-left: 8px;
                cursor: pointer;
                -webkit-tap-highlight-color: transparent;
                @include mobile {
                    margin-left: 4px;
                }
            }

            &-desc {
                color: $gray;
            }
        }

        &-total {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: bold;
            padding: 6px 0 12px;

            @include tablet {
                flex: 1;
                padding-top: 12px;
            }
            @include mobile {
                padding: 0 12px 8px;
            }

            &-label {
                font-size: 18px;
                line-height: 32px;
                @include mobile {
                    font-size: 16px;
                    line-height: 22px;
                }
            }

            &-value {
                font-size: 18px;
                line-height: 32px;
                @include mobile {
                    font-size: 16px;
                    line-height: 22px;
                }

                svg {
                    width: 10px;
                    height: 14px;
                    @include mobile {
                        width: 9px;
                        height: 13px;
                    }
                }
            }
        }

        &-btn {
            width: 100%;
            padding: 0px 35px;
            @include tablet {
                width: 165px;
                height: 40px;
                margin-left: 30px;
                padding: 0px 16px;
            }
            @include mobile {
                width: 100%;
                margin-left: 0;
            }
        }

        .count {
            margin-top: 13px;
        }

        &.opened {
            z-index: 100;
        }
    }
    &__order.abs {
        .order-services__order-border {
            @include mobile {
                padding: 12px 12px 35px;
            }
        }
    }

    &__filters {
        margin-bottom: 20px;
        position: relative;
        @include tablet {
            margin-bottom: 40px;
        }
        @include mobile {
            margin-bottom: 19px;
            display: block;
            .form__field {
                &:not(:last-child) {
                    margin-bottom: 10px;
                }
            }
        }

        &-checked {
            background: rgba(204, 238, 238, 0.43);
            border-radius: 5px;
            padding: 14px 120px 2px 20px;
            position: relative;
            margin-bottom: 20px;
            @include mobile {
                padding: 14px 14px 38px 12px;
                margin-bottom: 0;
            }

            &-item {
                display: inline-block;
                margin-right: 45px;
                margin-bottom: 14px;
                @include mobile {
                    font-size: 14px;
                    line-height: 17px;
                    margin-right: 19px;
                }

                span {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: center url(/local/templates/pnd/src/assets/i2/close.svg) no-repeat;
                    margin-left: 8px;
                    cursor: pointer;
                }
            }

            button {
                position: absolute;
                color: $accent;
                background-color: $white-true;
                height: 30px;
                border-radius: 5px;
                padding: 0 20px;
                top: 10px;
                right: 10px;
                border: none;
                outline: none;
                cursor: pointer;
                @include mobile {
                    top: auto;
                    bottom: 11px;
                    right: 14px;
                }
            }
        }
    }

    &__search {
        .form__field-wrapper {
            height: 56px;
            background: right 19px center url(/local/templates/pnd/src/assets/i2/search.svg) no-repeat;
            
        }

        input {
            padding: 16px 50px 0 12px;
            @include mobile {
                height: 45px;
                padding: 20px 50px 0 12px;
            }
        }
    }

    &__services-filter {
        margin: 0 10px;
        width: 300px;
        @include tablet {
            width: 314px;
        }
        @include mobile {
            width: auto;
        }

        .checkbox {
            input {
                &:checked {
                    & + label {
                        .checkbox-icon {
                            background-size: 15.2px;
                        }
                    }
                }
            }

            label {
                width: 100%;
                font-size: 15px;
                line-height: 18px;
                padding: 3px 0 3px 34px;
                word-wrap: break-word;
                overflow-wrap: break-word;
                @include mobile {
                    display: block;
                    padding: 3px 34px 3px 0;
                }
            }

            &-icon {
                width: 24px;
                height: 24.8px;
                background: $border2;
                @include mobile {
                    left: auto;
                    right: 0;
                }
            }
        }

        &-label {
            border: 1px solid rgba(125, 121, 135, 0.2);
            border-radius: 5px;
            padding: 0 20px;
            line-height: 54px;
            cursor: pointer;
            position: relative;

            &::after {
                position: absolute;
                content: '';
                display: block;
                width: 15px;
                height: 9px;
                background: center url(/local/templates/pnd/src/assets/i2/dropdown.svg) no-repeat;
                right: 24px;
                top: 50%;
                transform: translateY(-50%);

                .opened & {
                    transform: translateY(-50%) rotate(180deg);
                }
            }
        }

        &-dropdpwn {
            display: none;
            position: absolute;
            left: 10px;
            right: 10px;
            background: $white-true;
            border: 1px solid rgba(125, 121, 135, 0.1);
            border-radius: 5px;
            margin-top: 30px;
            box-shadow: 10px 14px 50px rgba(229, 233, 246, 0.8);
            padding: 33px 23px 18px;
            z-index: 100;

            .opened & {
                display: block;
                @include mobile {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 100%;
                    overflow: auto;
                    margin-top: 0;
                    z-index: 101;
                    border: none;
                    border-radius: 0;
                    padding: 0 12px 20px;
                }
            }

            &::after {
                content: '';
                width: 33px;
                height: 33px;
                position: absolute;
                border-top: 1px solid rgba(125, 121, 135, 0.1);
                border-right: 1px solid rgba(125, 121, 135, 0.1);
                transform: rotate(-45deg);
                top: -17px;
                left: 66.6%;
                background: $white-true;
            }
        }

        &-list {
            display: block;
            column-count: 3;
            break-inside: avoid;
            padding-bottom: 40px;
            border-bottom: 1px solid rgba(125, 121, 135, 0.2);
            @include mobile {
                column-count: 1;
                margin-top: 10px;
                border-bottom: none;
            }
        }

        &-col {
            width: calc(100% / 3);
            box-sizing: border-box;
            padding-right: 20px;
            @include mobile {
                width: 100%;
                padding-right: 0px;
                &:not(:last-child) {
                    margin-bottom: 9px;
                }
            }
        }

        &-item {
            display: inline-block;
            vertical-align: top;
            width: 100%;
            word-wrap: break-word;
            overflow-wrap: break-word;

            &:not(:last-child) {
                margin-bottom: 15px;
                @include mobile {
                    margin-bottom: 9px;
                }
            }
        }

        &-btns {
            display: flex;
            justify-content: space-between;
            padding-top: 14px;
            @include mobile {
                padding-top: 5px;
            }

            button {
                height: 30px;
                line-height: 30px;
                @include mobile {
                    height: 38px;
                }

                &.button_light {
                    border: 1px solid rgba(0, 171, 170, 0.2);
                    padding: 0 10px;
                    @include mobile {
                        flex: 2;
                        margin-right: 10px;
                    }
                }

                &.button_dark {
                    padding: 0 20px;
                    @include mobile {
                        flex: 3;
                    }
                }
            }
        }
    }

    &__pagination {
        display: flex;
        font-size: 14px;
        line-height: 28px;
        @include mobile {
            justify-content: space-between;
            line-height: 24px;
        }

        &-pages {
            border: 1px solid rgba(125, 121, 135, 0.15);
            border-radius: 5px;
            margin-right: 10px;
            display: flex;
            @include mobile {
                margin-right: 5px;
            }

            a {
                display: block;
                width: 36px;
                height: 28px;
                text-align: center;
                cursor: pointer;
                outline: none;
                @include mobile {
                    width: 28px;
                    height: 24px;
                }

                &.active {
                    background: rgba(125, 121, 135, 0.1);
                }

                &:not(:nth-last-child(2)) {
                    border-right: 1px solid rgba(125, 121, 135, 0.15);
                }
            }

            .hidden {
                display: none;
            }
        }

        &-showall {
            height: 30px;
            width: 123px;
            text-align: center;
            cursor: pointer;
            border-radius: 5px;
            border: 1px solid rgba(125, 121, 135, 0.15);
            -webkit-tap-highlight-color: transparent;
            @include mobile {
                height: 26px;
                font-size: 12px;
                width: 93px;
            }
        }
    }

    &__buttons-disclaimer {
        margin-top: 58px;

        @include tablet {
            margin-top: 40px;
        }
        @include mobile {
            margin-top: 30px;
        }
    }

    &__buttons {
        margin-top: 58px;

        @include tablet {
            margin-top: 40px;
        }
        @include mobile {
            margin-top: 30px;
            display: flex;
            flex-direction: column;
        }

        .button {
            margin-right: 10px;
            @include tablet {
                height: 50px;
            }
            @include mobile {
                margin-right: 0;
                width: 100%;
                &:not(:first-child) {
                    margin-bottom: 10px;
                }
                &.button_dark {
                    order: -1;
                }
            }
        }
    }

    &__buttons-disclaimer + &__buttons {
        margin-top: 10px;
    }

    &__price-disclaimer {
        width: 100%;
        padding: 15px 0;
        color: #7D7987;
        font-size: 14px;
        line-height: 21px;
    }

    ._disabled {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
